import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { FileIconSize, Icon } from "./icon";
import { getConcatUrl, mimetypeAdaptor } from "../util/utils";
import { PADDING_PERCENT, THUMBNAIL_BORDER_PERCENT } from "../util/const";
import { useGetFileIconOrThumbnail } from "../hooks/use-get-icon";
import { CacheImageDetection, DetectStatus } from "../util/cache-image-detection";
import { FileIconFormat } from "./file-icon-url";
import { isIOS, isSafari } from "../util/ua";

/**
 * icon 上贴图配置（如快捷方式角标等）
 */

export var FileIconFactory = function FileIconFactory(params) {
  return function (props) {
    var getMachine = params.getMachine,
      defaultIconUrl = params.defaultIconUrl;
    var _props$size = props.size,
      size = _props$size === void 0 ? FileIconSize.Default : _props$size,
      mimeType = props.mimeType,
      extensionName = props.extensionName,
      docType = props.docType,
      padType = props.padType,
      docThumbnail = props.docThumbnail,
      isCollaboration = props.isCollaboration,
      className = props.className,
      style = props.style,
      _props$stickerConfig = props.stickerConfig,
      stickerConfig = _props$stickerConfig === void 0 ? {
        shortcut: false,
        playButton: false
      } : _props$stickerConfig,
      children = props.children,
      onClick = props.onClick,
      _props$format = props.format,
      format = _props$format === void 0 ? isIOS() || isSafari() ? FileIconFormat.PNG : FileIconFormat.SVG : _props$format;
    var currentMimeType = mimetypeAdaptor({
      mimeType: mimeType,
      docType: docType,
      isCollaboration: isCollaboration,
      padType: padType,
      extensionName: extensionName
    });

    // 无法推断 mimeType 的情况直接返回异常 ui
    // 并将本次渲染上下文写到 url 方便排查问题
    if (!currentMimeType) {
      var context = "__fileIconException_".concat(size, "_").concat(mimeType, "_").concat(docType, "_").concat(isCollaboration, "_").concat(padType, "_").concat(extensionName, "_").concat(format);
      return /*#__PURE__*/React.createElement(FileIconSync, {
        libIconUrl: context,
        concatUrl: context,
        size: size,
        className: className,
        style: style,
        stickerConfig: stickerConfig,
        onClick: onClick,
        children: children
      });
    }
    var machine = getMachine(size, format);

    // 寻找库中是否有 fileIcon 资源
    var libIconUrl = machine.run(currentMimeType);
    var concatUrl = getConcatUrl(currentMimeType, format);
    if (libIconUrl || defaultIconUrl || CacheImageDetection.get(concatUrl) === DetectStatus.Success) {
      return /*#__PURE__*/React.createElement(FileIconSync, {
        libIconUrl: libIconUrl,
        concatUrl: defaultIconUrl !== null && defaultIconUrl !== void 0 ? defaultIconUrl : concatUrl,
        size: size,
        className: className,
        style: style,
        stickerConfig: stickerConfig,
        onClick: onClick,
        children: children
      });
    }
    return /*#__PURE__*/React.createElement(FileIconAsync, {
      libIconUrl: libIconUrl,
      concatUrl: concatUrl,
      size: size,
      className: className,
      style: style,
      stickerConfig: stickerConfig,
      onClick: onClick,
      children: children,
      docThumbnail: docThumbnail,
      mimeType: currentMimeType
    });
  };
};
var FileIconSync = function FileIconSync(props) {
  var libIconUrl = props.libIconUrl,
    concatUrl = props.concatUrl,
    size = props.size,
    className = props.className,
    style = props.style,
    stickerConfig = props.stickerConfig,
    onClick = props.onClick,
    children = props.children;
  return /*#__PURE__*/React.createElement(Icon, {
    src: libIconUrl !== null && libIconUrl !== void 0 ? libIconUrl : concatUrl,
    size: size,
    className: className,
    style: style,
    stickerConfig: stickerConfig,
    onClick: onClick
  }, children);
};
var FileIconAsync = function FileIconAsync(props) {
  var mimeType = props.mimeType,
    docThumbnail = props.docThumbnail,
    libIconUrl = props.libIconUrl,
    concatUrl = props.concatUrl,
    _props$size2 = props.size,
    size = _props$size2 === void 0 ? FileIconSize.Default : _props$size2,
    className = props.className,
    style = props.style,
    stickerConfig = props.stickerConfig,
    onClick = props.onClick,
    children = props.children;
  var _useGetFileIconOrThum = useGetFileIconOrThumbnail({
      mimeType: mimeType,
      thumbnail: docThumbnail,
      libIconUrl: libIconUrl,
      concatUrl: concatUrl
    }),
    iconURL = _useGetFileIconOrThum.iconURL,
    isThumbnail = _useGetFileIconOrThum.isThumbnail;
  var thumbnailStyle = {
    padding: "".concat(size * PADDING_PERCENT, "px"),
    borderRadius: THUMBNAIL_BORDER_PERCENT
  };
  return /*#__PURE__*/React.createElement(Icon
  // 缩略图加载完成后不再使用 icon URL
  , {
    src: isThumbnail ? docThumbnail : iconURL,
    size: size,
    className: className,
    style: isThumbnail ? _objectSpread(_objectSpread({}, style), thumbnailStyle) : _objectSpread({}, style),
    stickerConfig: stickerConfig,
    onClick: onClick
  }, children);
};
//# sourceMappingURL=file-icon-factory.js.map